//api域名
const baseUrl = {
    shopopee: process.env.NODE_ENV === 'production' ? 'https://www.3dshopopee.com/' : 'http://127.0.0.1:91/',

    shopopeeHttp: process.env.NODE_ENV === 'production' ? 'https://www.3dshopopee.com/shopopeeApi/' : 'http://127.0.0.1:91/shopopeeApi/',
    eshopopee: process.env.NODE_ENV === 'production' ? 'shop02.e-shopopee.com' : '127.0.0.1:91/eshopopee',
    threeDShopopeePath: process.env.NODE_ENV === 'production' ? "https://www.3dshopopee.com/3d/" : "http://192.168.3.15:8081/",
    chatHttp: process.env.NODE_ENV === 'production' ? "https://www.3dshopopee.com/api" : "http://192.168.1.5:91/api",
    SSL: process.env.NODE_ENV === 'production' ? "https" : "http",
    projectPath: process.env.NODE_ENV === 'production' ? "3d/" : ""
}

export default baseUrl